import { queryApp } from 'hooks/apolloQuery.js'
import getImageContentList from '@/apollo/queries/getImageContentList.gql'

export function collectPropsContentImages(propsContentLists) {
  return propsContentLists.flatMap((list) =>
    (list ?? []).flatMap((entry) => (entry?.images ?? []).filter((img) => img?.id != null)),
  )
}

export async function enrichPropsContentImages(propsContentLists) {
  const images = collectPropsContentImages(propsContentLists)
  const ids = Array.from(new Set(images.map((img) => Number(img.id)).filter(Boolean)))

  if (!ids.length) {
    return
  }

  let imageMap = {}

  try {
    const { data } = await queryApp(getImageContentList, { id: ids })

    imageMap = (data?.imageContentList ?? []).reduce((acc, item) => {
      acc[String(item.id)] = item.compressedImage
      return acc
    }, {})
  } catch (err) {
    console.error('[loyalty] propsContent images fetch failed', err)
    return
  }

  images.forEach((img) => {
    const compressedImage = imageMap[String(img.id)]
    if (compressedImage) {
      img.compressedImage = compressedImage
    }
  })
}
